import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

class LoadingSpinner extends Component {
  render() {
    return (
      <Row>
        <Col>
          <img src="/public/images/spin.gif" className="spinner" />
        </Col>
      </Row>
    );
  }
}

export default LoadingSpinner;
